// if IE 11 only
// @ts-ignore
const ua = window.navigator.userAgent;
const msie = ua.indexOf('MSIE ');

const CHUNK_LOAD_RETRY_KEY = 'chunk-load-retry-attempted';

const reloadAfterServiceWorkerUpdate = async (error: unknown) => {
  console.error('Failed to load application bundle or polyfills', error);

  if (sessionStorage.getItem(CHUNK_LOAD_RETRY_KEY)) {
    return;
  }

  sessionStorage.setItem(CHUNK_LOAD_RETRY_KEY, 'true');

  try {
    const registration = await navigator.serviceWorker?.getRegistration();
    await registration?.update();
  } catch (updateError) {
    console.warn('Failed to update Service Worker before retrying', updateError);
  } finally {
    window.location.reload();
  }
};

if (msie > 0) {
  // IE < 11
  window.location.replace('ie.html');
} else {
  const polyfills: any[] = [];
  // @ts-ignore
  // IE 11
  if (!!window.MSInputMethodContext && !!document.documentMode) {
    console.debug('Adding polyfills');
    // @ts-ignore
    polyfills.push(import('react-app-polyfill/ie11'));
    // @ts-ignore
    polyfills.push(import('react-app-polyfill/stable'));
  }
  // All browsers
  Promise.all(polyfills)
    // @ts-ignore
    .then(() => import('./main'))
    .then(() => sessionStorage.removeItem(CHUNK_LOAD_RETRY_KEY))
    // @ts-ignore
    .catch(reloadAfterServiceWorkerUpdate);
}